module.exports = __webpack_public_path__ + "img/beastmastery.2173a537.jpg";